import { Card, CardBody, Spinner } from "@heroui/react";
import { useTranslation } from "react-i18next";
import { useLocation } from "wouter";
import type { TDocumentTemplate } from "@shared/entities";

type Props = {
  templates: TDocumentTemplate[];
  templatesLoading: boolean;
  selectedTemplate: TDocumentTemplate | null;
  onSelect: (template: TDocumentTemplate) => void;
};

export function TemplateStep1({ templates, templatesLoading, selectedTemplate, onSelect }: Props) {
  const { t } = useTranslation("doctorTemplates");
  const [, navigate] = useLocation();

  if (templatesLoading) {
    return (
      <div className="flex justify-center py-8">
        <Spinner />
      </div>
    );
  }

  if (templates.length === 0) {
    return (
      <div className="flex flex-col items-center gap-2 py-8 text-default-500">
        <span>{t("noTemplatesCreate")}</span>
        <button
          type="button"
          className="text-primary underline cursor-pointer"
          onClick={() => navigate("/doctor/templates/new")}
        >
          {t("createTemplate")}
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {templates.map((template) => {
        const isSelected = selectedTemplate?.id === template.id;
        return (
          <Card
            key={template.id}
            isPressable
            onPress={() => onSelect(template)}
            className={isSelected ? "border-2 border-primary" : "border-2 border-transparent"}
          >
            <CardBody>
              <span className="font-medium">{template.title}</span>
            </CardBody>
          </Card>
        );
      })}
    </div>
  );
}
